import {match, Pattern} from 'ts-pattern';

import type {BulkOperationResponseBody} from '../types/api/bulkOperations';
import {isBulkOperationSettling} from './isBulkOperationSettling';

type BulkOperationRecoveryInput = Pick<
  BulkOperationResponseBody,
  'state' | 'failedCount' | 'finishedAt'
>;

/** A cancelled run reruns only its failed records, and only once they all reported. */
export function getBulkOperationRecoveryAction(operation: BulkOperationRecoveryInput) {
  return match(operation)
    .with({state: Pattern.union('PARTIALLY_DONE', 'FAILED')}, () => 'rerunFailed' as const)
    .with({state: 'RESOLVE_FAILED'}, () => 'tryAgain' as const)
    .with({state: 'CANCELLED'}, (value) =>
      value.failedCount > 0 && !isBulkOperationSettling(value) ? ('rerunFailed' as const) : null
    )
    .with({state: Pattern.union('PENDING', 'IN_PROGRESS', 'DONE')}, () => null)
    .exhaustive();
}
